import { AuthState } from "./AuthState";

type RemoteState = {
  errors: { error: any | undefined };
};

type GlobalState = RemoteState & {
  auth: AuthState;
};

export const isAuthedSelector = (state: GlobalState) =>
  state.auth.loginStatus === "LOGGED_IN";

export const authStatusSelector = (state: GlobalState) =>
  state.auth.loginStatus;

export const userSelector = (state: GlobalState) => state.auth.user;

export const errorSelector = (state: GlobalState) => state.errors.error;
